import { Link } from 'react-router-dom';
import { rankings, mangaData } from '@/mocks/manga';

export default function TopRanking() {
  const topManga = rankings.slice(0, 10);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热门排行
          </h2>
          <p className="text-sm text-foreground-600 max-w-md mx-auto">
            根据人气和评分综合排序，发现最受欢迎的漫画
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {topManga.map((item, index) => {
            const manga = mangaData.find((m) => m.id === item.mangaId);
            if (!manga) return null;

            return (
              <Link
                key={manga.id}
                to={`/manga/${manga.id}`}
                className="flex items-center gap-4 p-4 bg-background-100 rounded-lg hover:bg-primary-50 transition-all duration-200 group cursor-pointer"
              >
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                  {index < 3 ? (
                    <span className={`text-lg font-heading font-bold ${
                      index === 0 ? 'text-accent-500' :
                      index === 1 ? 'text-accent-400' :
                      'text-accent-300'
                    }`}>
                      {index + 1}
                    </span>
                  ) : (
                    <span className="text-sm font-medium text-foreground-500">{index + 1}</span>
                  )}
                </div>

                <div className="flex-shrink-0 w-14 h-20 rounded-md overflow-hidden">
                  <img
                    src={manga.cover}
                    alt={manga.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {manga.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{manga.author}</p>
                  <div className="flex items-center gap-3 mt-1.5">
                    <span className="text-xs font-medium text-accent-600">
                      <i className="ri-star-fill text-xs mr-0.5"></i>
                      {manga.rating}
                    </span>
                    <span className="text-xs text-foreground-400">{manga.views}</span>
                    <span className="text-xs text-foreground-400">{manga.category}</span>
                  </div>
                </div>

                <div className="flex-shrink-0 flex items-center">
                  {item.trend === 'up' && (
                    <span className="text-secondary-500 text-xs flex items-center gap-0.5">
                      <i className="ri-arrow-up-fill"></i>
                      {item.change > 0 ? `+${item.change}` : ''}
                    </span>
                  )}
                  {item.trend === 'down' && (
                    <span className="text-accent-500 text-xs flex items-center gap-0.5">
                      <i className="ri-arrow-down-fill"></i>
                      {Math.abs(item.change)}
                    </span>
                  )}
                  {item.trend === 'stable' && (
                    <span className="text-foreground-400 text-xs">
                      <i className="ri-subtract-line"></i>
                    </span>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}